export const WhatsAppInfo = 'whatsappInfoStatus';

export const RECEIVE_UPDATES_INFO = 'receiveUpdatesInfoStatus';

export const allowedCountryCodeEnums = ['IN'];
